import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SearchBar from "../SearchBar";

export default function PublicLayout({ children }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isHome = location.pathname === "/";

  const initialWhere = searchParams.get("q") || "";
  const initialFrom = searchParams.get("from")?.split("T")[0] || "";
  const initialUntil = searchParams.get("until")?.split("T")[0] || "";

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      {!isHome && (
        <div className="sticky top-16 z-40 bg-[#2A9D8F] py-2 px-3 shadow-sm">
          <div className="mx-auto max-w-3xl">
            <SearchBar
              initialWhere={initialWhere}
              initialFrom={initialFrom}
              initialUntil={initialUntil}
            />
          </div>
        </div>
      )}
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
